import { getProvidersData } from '../../helpers/data-helper';

export default {
	data: function() {
		return {
			providers_data: {},
			providers: []
		}
	},
	mounted: function() {
		this.providers_data = getProvidersData();
		for(var key in this.providers_data) {
			this.providers.push(key);
		}
		analytics.page({type: 'page', name: 'Landing', path: 'Landing'}, {integrations: {'AdWords': false}});
	},
	methods: {
		navigate: function() {
			this.$router.push('/compare');
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/home.js